var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrait(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.422,
    height: 247.016,
    viewBox: "0 0 103.422 247.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2571",
    "data-name": "Groupe 2571",
    transform: "translate(1.01 1.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_893",
    "data-name": "Trac\\xE9 893",
    d: "M-7619.579-5277.692s-134.48,11.449-21.179,168.925",
    transform: "translate(7686.154 5277.692)",
    fill: "none",
    stroke: "#f9c977",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_894",
    "data-name": "Trac\\xE9 894",
    d: "M0,0C31.087,11.322,43.939,44.329,27.113,44.047S30.134-4.89,67.126,22.638",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 45.891, 168.925)",
    fill: "none",
    stroke: "#f9c977",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrait);
export default __webpack_public_path__ + "static/media/trait.a334efa17264fb135590acbc27cd6953.svg";
export { ForwardRef as ReactComponent };